import axios from 'axios';
import {axiosPostConfig} from './config';
import { QUOTES_API, ORDERS_API, LEADS_API } from '../const.js.erb';

const axiosPostInstance = axios.create({
  ...axiosPostConfig,
})

export const createOrder = (data) => axiosPostInstance.post(ORDERS_API, data)
export const fetchQuote = (data) => axiosPostInstance.post(QUOTES_API, data)

export const createLead = (data) => {
  const defaultValue = {
    context: 'nest_maintenance',
    collecting_url: window.location.href,
    created_through: 'live_submission',
  }
  return axiosPostInstance.post(LEADS_API, { lead: {...defaultValue, ...data} })
}
